<template>
  <div v-if="videos.length > 0" class="landing_slider">
    <div class="landing_slider_title">
      <b>Trending Videos</b>
    </div>
    <!--
    <div class="view_more landing_event_btn">
      <a :href="routeVideos()" class="view_all_event">View More Videos</a>
    </div>
    -->
    <button
      v-if="pagination.running"
      type="button"
      data-role="none"
      class="slick-next-loading slick-arrow"
      aria-label="Next"
      role="button"
      aria-disabled="false"
    >
      <img class="lazyload" :data-src="contentCloudFrontWithVersion('/ellipsis.svg')" style="top: 100% !important; right: 35px;">
    </button>
    <div ref="videos_slider" class="videos_slider variable-width-twitch">
      <trending-video-item v-for="video in videos" :key="video.id" :video="video" />
    </div>
    <!-- comment for issue GAME - 8754 -->
    <!-- <div v-if="checkLightTheme()" class="light-theme-slick-arrow">
      <div ref="arrow_prev" class="light_theme_arrow left" />
      <div ref="arrow_next" class="light_theme_arrow right" />
    </div> -->
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import { helper } from '../../../mixins/helper';
import { LandingAPI } from '../../../api/landing';
import TrendingVideoItem from './TrendingVideoItem';
import Vue from 'vue';
import 'slick-carousel/slick/slick.min';
import jQuery from 'jquery';

export const SLICK_RESPONSIVE_CONFIG_LANDING_COMMUNITY = [
  {
    breakpoint: 1500,
    settings: {
      infinite: false,
      initialSlide: 0,
      slidesToShow: 5,
      slidesToScroll: 5,
      variableWidth: true,
      centerMode: false,
    },
  },
  {
    breakpoint: 1220,
    settings: {
      initialSlide: 0,
      slidesToShow: 4,
      slidesToScroll: 4,
      variableWidth: true,
      centerMode: false,
      infinite: false,
    },
  },
  {
    breakpoint: 1000,
    settings: {
      initialSlide: 0,
      slidesToShow: 3,
      slidesToScroll: 3,
      variableWidth: true,
      centerMode: false,
      infinite: false,
    },
  },
  {
    breakpoint: 840,
    settings: {
      initialSlide: 0,
      slidesToShow: 2,
      slidesToScroll: 2,
      variableWidth: true,
      centerMode: false,
      infinite: false,
    },
  },
  {
    breakpoint: 500,
    settings: {
      initialSlide: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      centerMode: false,
      infinite: false,
    },
  },
];

export default {
  components: { TrendingVideoItem },
  mixins: [component, LandingAPI, helper],
  data() {
    return {
      videos: [],
      pagination: {
        page: 1,
        running: false,
      },
    };
  },
  created() {
    this.getTrendingVideos();
  },
  methods: {
    async getTrendingVideos() {
      this.videos = await this.getListTrendingVideoAPI(this.pagination.page);
      this.pagination.page++;
      Vue.nextTick(() => {
        this.initSlick();
      });
    },
    initSlick() {
      // comment for issue GAME - 8754
      // if (this.checkLightTheme()) {
      //   jQuery(this.$refs.videos_slider).slick({
      //     infinite: false,
      //     speed: 300,
      //     slidesToShow: 3,
      //     centerMode: false,
      //     variableWidth: true,
      //     initialSlide: 0,
      //     draggable: false,
      //     slidesToScroll: 3,
      //     responsive: SLICK_RESPONSIVE_CONFIG_LANDING_COMMUNITY,
      //     prevArrow: jQuery(this.$refs.arrow_prev),
      //     nextArrow: jQuery(this.$refs.arrow_next),
      //   });
      // } else {
      jQuery(this.$refs.videos_slider).slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        centerMode: false,
        variableWidth: true,
        initialSlide: 0,
        draggable: false,
        slidesToScroll: 3,
        responsive: SLICK_RESPONSIVE_CONFIG_LANDING_COMMUNITY,
      });
      // }
      this.loadMoreSlick();
    },
    loadMoreSlick(){
      jQuery(this.$refs.videos_slider).on('afterChange', async(event, slick, currentSlide) => {
        const elem = jQuery(this.$refs.videos_slider);
        let slidesToShow = slick.slickGetOption('slidesToShow');

        elem.find('.slick-next').first().css('background-color', '#ff6b22');
        elem.find('.slick-prev').first().css('background-color', '#686a7b');
        if (slidesToShow === 1) {
          slidesToShow = slidesToShow + 2;
        } else {
          if (currentSlide >= slick.slideCount - slidesToShow) {
            // TODO: handle load more not using anymore
            if (!this.pagination.running){
              this.pagination.running = true;
              const loadmoreVideos = await this.getListTrendingVideoAPI(this.pagination.page);
              this.pagination.page++;
              this.pagination.running = false;
              if (loadmoreVideos.length > 0){
                this.destroySlick();

                for (let i = 0; i < loadmoreVideos.length; i++){
                  this.videos.push(loadmoreVideos[i]);
                }
                Vue.nextTick(() => {
                  this.initSlick();
                  jQuery(this.$refs.videos_slider).slick('slickGoTo', currentSlide, true);
                });
              } else {
                elem.find('.slick-next').first().addClass('btn_slick_disable');
              }
            }
          }
        }
        return true;
      });
    },
    destroySlick(){
      jQuery(this.$refs.videos_slider).off('afterChange');
      jQuery(this.$refs.videos_slider).slick('unslick');
    },
  },
};
</script>
